import React from "react";
import { connect } from "react-redux";
import { ActiveService } from "../components/buttons/ActiveService";
import { saveSettings, loadSettings } from "../actions/settingActions";
import { Link } from "react-router-dom";

import "./Footer.css";

function AvaliableMedia(props) {
  const route = "/settings/duringcalls/media";

  const toSettings = props.toSettings.replace(
    "%",
    props.mediaText.toLowerCase()
  );

  return (
    <ul className={"avaliable-services"}>
      {props.audioAvaliable && props.buttonsInFooter && (
        <ActiveService
          setting={"audio"}
          active={props.audioActive}
          icon={props.audioActive === "true" ? "mic" : "mic_off"}
          icon2={props.audioActive === "true" ? "volume_up" : "volume_off"}
          doubleIcons={props.doubleIcons}
          title={props.audioActive === "true" ? props.micon : props.micoff}
          text={
            props.textOnButtons
              ? props.audioActive === "true"
                ? props.micon
                : props.micoff
              : ""
          }
          onClick={props.onClick}
        />
      )}
      {props.videoAvaliable && props.buttonsInFooter && (
        <ActiveService
          setting={"video"}
          active={props.videoActive}
          icon={props.videoActive === "true" ? "videocam" : "videocam_off"}
          title={
            props.videoActive === "true" ? props.cameraon : props.cameraoff
          }
          text={
            props.textOnButtons
              ? props.videoActive === "true"
                ? props.cameraon
                : props.cameraoff
              : ""
          }
          onClick={props.onClick}
        />
      )}
      {props.mediaSettings && props.linkInFooter && (
        <li className={"service-icons"} aria-label={toSettings}>
          <Link
            className={"btn avaliable-services-button"}
            to={route}
            title={toSettings}
            aria-label={props.ariaLabel}
          >
            <i
              aria-hidden="true"
              className={
                "material-icons service-icon vertical-align-middle" +
                (props.textOnButtons ? " margin-right-0_2em" : "")
              }
            >
              {"settings"}
            </i>
            {props.textOnButtons && (
              <span className="button-text">{toSettings}</span>
            )}
          </Link>
        </li>
      )}
    </ul>
  );
}

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer-div">
        {this.props.isLoggedIn ? (
          <AvaliableMedia
            ariaLabel={this.props.ariaLabel}
            audioAvaliable={this.props.audioAvaliable}
            audioActive={this.props.audioActive}
            videoAvaliable={this.props.videoAvaliable}
            videoActive={this.props.videoActive}
            textAvaliable={this.props.textAvaliable}
            mediaSettings={
              this.props.mediaSettings &&
              (this.props.audioAvaliable || this.props.videoAvaliable)
            }
            buttonsInFooter={this.props.buttonsInFooter}
            linkInFooter={this.props.linkInFooter}
            doubleIcons={this.props.doubleIcons}
            micon={this.props.micon}
            micoff={this.props.micoff}
            cameraon={this.props.cameraon}
            cameraoff={this.props.cameraoff}
            texton={this.props.texton}
            toSettings={this.props.toSettings}
            onClick={this.props.saveSettings}
            textOnButtons={this.props.textOnButtons}
            mediaText={
              this.props.audioAvaliable && this.props.videoAvaliable
                ? this.props.audioText + "/" + this.props.videoText
                : this.props.videoAvaliable
                ? this.props.videoText
                : this.props.audioText
            }
          />
        ) : null}
        <div className="footer-text">{this.props.text}</div>
      </footer>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.user.authenticated,
    text: state.config.text("common.copyright"),
    audioAvaliable: state.config.audio,
    audioActive: state.setting.user.WEB_AUDIO,
    videoAvaliable: state.config.video,
    videoActive: state.setting.user.WEB_VIDEO,
    textAvaliable: state.config.mode.safetext,
    textOnButtons: state.config.mode.text_in_footer,
    mediaSettings: state.config.mode.setting_media_enabled,
    linkInFooter: state.config.mode.link_to_settings_in_footer,
    buttonsInFooter: state.config.mode.buttons_in_footer,
    doubleIcons: state.config.mode.use_double_audio_icons_in_footer,
    ariaLabel: state.config.text("aria.link_sound_video"),
    micon: state.config.text("toolbar.useaudioon"),
    micoff: state.config.text("toolbar.useaudiooff"),
    cameraon: state.config.text("toolbar.usevideoon"),
    cameraoff: state.config.text("toolbar.usevideooff"),
    texton: state.config.text("toolbar.usetexton"),
    textoff: state.config.text("toolbar.usetextoff"),
    toSettings: state.config.text("toolbar.toSettings"),
    audioText: state.config.text("settings.audio"),
    videoText: state.config.text("settings.video"),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveSettings: values => {
      return dispatch(saveSettings(values));
    },
    loadSettings: () => {
      return dispatch(loadSettings());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);






// WEBPACK FOOTER //
// ./src/containers/Footer.js